/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './ApplicationsInstallRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getPortalInstallAvailabilityByUserId
 */
export const GET_PORTAL_INSTALL_AVAILABILITY_BY_USER_ID_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getPortalInstallAvailabilityByUserId';
export const GET_PORTAL_INSTALL_AVAILABILITY_BY_USER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_INSTALL_AVAILABILITY_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['applicationId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPortalInstallAvailabilityByUserIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getOAuthPortalPickerResponseForUser
 */
export const GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_USER_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getOAuthPortalPickerResponseForUser';
export const GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_USER_QUERY_FIELD_NAME,
  args: ['clientId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getOAuthPortalPickerResponseForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getOAuthPortalPickerResponseForPortal
 */
export const GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getOAuthPortalPickerResponseForPortal';
export const GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OAUTH_PORTAL_PICKER_RESPONSE_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['clientId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getOAuthPortalPickerResponseForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getProbationalMarketplaceDistAppTotalInstallsLimit
 */
export const GET_PROBATIONAL_MARKETPLACE_DIST_APP_TOTAL_INSTALLS_LIMIT_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getProbationalMarketplaceDistAppTotalInstallsLimit';
export const GET_PROBATIONAL_MARKETPLACE_DIST_APP_TOTAL_INSTALLS_LIMIT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROBATIONAL_MARKETPLACE_DIST_APP_TOTAL_INSTALLS_LIMIT_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getProbationalMarketplaceDistAppTotalInstallsLimitRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getPortalsAccessibleToUser
 */
export const GET_PORTALS_ACCESSIBLE_TO_USER_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getPortalsAccessibleToUser';
export const GET_PORTALS_ACCESSIBLE_TO_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTALS_ACCESSIBLE_TO_USER_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getPortalsAccessibleToUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getAppInstallAllowlistWithDetails
 */
export const GET_APP_INSTALL_ALLOWLIST_WITH_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getAppInstallAllowlistWithDetails';
export const GET_APP_INSTALL_ALLOWLIST_WITH_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_INSTALL_ALLOWLIST_WITH_DETAILS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getAppInstallAllowlistWithDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#checkAppAllowlistStatusForPortals
 */
export const CHECK_APP_ALLOWLIST_STATUS_FOR_PORTALS_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_checkAppAllowlistStatusForPortals';
export const CHECK_APP_ALLOWLIST_STATUS_FOR_PORTALS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_APP_ALLOWLIST_STATUS_FOR_PORTALS_QUERY_FIELD_NAME,
  args: ['appId', 'portalIds'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.checkAppAllowlistStatusForPortalsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc#getPortalTierUpgradesRequiredToInstallApp
 */
export const GET_PORTAL_TIER_UPGRADES_REQUIRED_TO_INSTALL_APP_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsInstallRpc_getPortalTierUpgradesRequiredToInstallApp';
export const GET_PORTAL_TIER_UPGRADES_REQUIRED_TO_INSTALL_APP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_TIER_UPGRADES_REQUIRED_TO_INSTALL_APP_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getPortalTierUpgradesRequiredToInstallAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});